module.exports = __webpack_public_path__ + "img/obs_water_caution_up.8950b763.svg";